import styled from "styled-components";
import { Alert, Icon } from "antd";

export const NoticeContainer = styled(Alert)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue}
  background-color: ${props => props.theme.backgroundColor.cardDark}
  border-radius: 0px;
  border: none;
  padding: 20px 30px !important;
  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
    font-size: ${props => props.theme.fontSize.tertiary};
    padding: 20px !important;
  }
`;

export const NoticeContent = styled.div`
  justify-content: space-between !important;
  align-items: center;
  & > div:nth-child(1) {
    flex-basis: 75%;
    span {
    }
  }
  & > button {
    flex-basis: 15%;
  }
  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
    justify-content: space-between !important;
    & > div:nth-child(1) {
      flex-basis: 75%;
      margin-bottom: 1rem;
      line-height: 1.67;
    }
    & > button {
      width: initial;
      align-self: flex-start;
    }
  }
`;

export const Strip = styled.div`
  height: 6px;
  background-color: ${props => props.theme.colors.info};
`;

export const DownIcon = styled(Icon)`
  font-size: 10px;
  padding-top: 0.24rem;
`;
